var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":"Leads","subtitle":_vm.subtitle}},[_c('div',[_c('Leads-Table',{attrs:{"toReceiveOnly":_vm.toReceiveOnly}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }